let INTEGER_TYPES: Array<string> = [
    "slope",
    "intercept",
    "sd slope",
    "sd intercept",
    "area",
    "rss",
    "residual",
    "mean area",
    "sd area",
    's',
    'sigma[1]',
    'sigma[2]',
    'sigma[3]'
];

let SOME_RSD : string = "some rsd data type replacer";

let PERCENT_TYPES: Array<string> = [
    'mean trueness',
    'sd trueness',
    'pooled sd trueness',
    SOME_RSD,
    'Maximum back-calculated concentration error',
    'Maximum back-calculated concentration error for LoQ',
    'Maximum RSD',
    'Maximum RSD for LoQ',
    'Back-calculated concentration - minimum per cent of levels passing',
    'Back-calculated concentration - minimum per cent of parallels passing per level'
];

// TODO: maybe don't output like this from math module
let SPECIAL_PERCENT_TYPES: Array<string> = [
    // is pre-multiplied by 100
    'bc concentration error',
    'trueness'
];

function format(val: any, data_type?: string) {

    if(data_type && (data_type.startsWith("rsd ") || data_type.startsWith("pooled rsd "))) {
        data_type = SOME_RSD
    }

    if (!isNaN(val)) {
        val = +val;


        if(data_type && INTEGER_TYPES.indexOf(data_type) > -1 && val > 100) {
            return Math.round(val)
        }

        if(data_type && PERCENT_TYPES.indexOf(data_type) > -1) {
            return (val*100).toPrecision(3) + "%"
        }

        if(data_type && SPECIAL_PERCENT_TYPES.indexOf(data_type) > -1) {
            return val.toPrecision(3) + "%"
        }

        if (val != 0 && Math.abs(val) < 0.0001) {
            return val.toExponential(2)
        }

        if (data_type == 'LoF tabulated') {
            return val;
        }

        if (val && val.toPrecision) {
            return Number(val.toPrecision(3))
        }

        return val; //should be 0
    }

    return val;
}
export default format

